"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CUSTOMER_SEGMENT = exports.STOCK_QUOTAS = exports.QUOTA_IGNORE_LIST = exports.FULFILLABLE_ITEM_CONSTANTS = exports.LICENSE_QUANTITY_UNLIMITED = exports.PRODUCT_FAMILY = exports.SALES_CHANNEL = exports.PRODUCT_BUYING_PROGRAM = exports.PRODUCT_APPLICABLE_OFFER_TYPE = exports.LICENSE_QUANTITY_STATUS = exports.FULFILLABLE_ITEM_TYPE = void 0;
var FULFILLABLE_ITEM_TYPE;

(function (FULFILLABLE_ITEM_TYPE) {
  FULFILLABLE_ITEM_TYPE["DESKTOP"] = "DESKTOP";
  FULFILLABLE_ITEM_TYPE["FEATURE"] = "FEATURE";
  FULFILLABLE_ITEM_TYPE["QUOTA"] = "QUOTA";
  FULFILLABLE_ITEM_TYPE["SERVICE"] = "SERVICE";
  FULFILLABLE_ITEM_TYPE["SUPPORT"] = "SUPPORT";
})(FULFILLABLE_ITEM_TYPE = exports.FULFILLABLE_ITEM_TYPE || (exports.FULFILLABLE_ITEM_TYPE = {}));

var LICENSE_QUANTITY_STATUS;

(function (LICENSE_QUANTITY_STATUS) {
  LICENSE_QUANTITY_STATUS["CANCELLING"] = "CANCELLING";
  LICENSE_QUANTITY_STATUS["GRACE_PAST_DUE"] = "GRACE_PAST_DUE";
  LICENSE_QUANTITY_STATUS["PAID"] = "PAID";
  LICENSE_QUANTITY_STATUS["PAST_DUE"] = "PAST_DUE";
  LICENSE_QUANTITY_STATUS["PENDING_PAYMENT"] = "PENDING_PAYMENT";
})(LICENSE_QUANTITY_STATUS = exports.LICENSE_QUANTITY_STATUS || (exports.LICENSE_QUANTITY_STATUS = {}));

var PRODUCT_APPLICABLE_OFFER_TYPE;

(function (PRODUCT_APPLICABLE_OFFER_TYPE) {
  PRODUCT_APPLICABLE_OFFER_TYPE["BASE"] = "BASE";
  PRODUCT_APPLICABLE_OFFER_TYPE["TRIAL"] = "TRIAL";
})(PRODUCT_APPLICABLE_OFFER_TYPE = exports.PRODUCT_APPLICABLE_OFFER_TYPE || (exports.PRODUCT_APPLICABLE_OFFER_TYPE = {}));

var PRODUCT_BUYING_PROGRAM;

(function (PRODUCT_BUYING_PROGRAM) {
  PRODUCT_BUYING_PROGRAM["ETLA"] = "ETLA";
  PRODUCT_BUYING_PROGRAM["RETAIL"] = "RETAIL";
  PRODUCT_BUYING_PROGRAM["VIP"] = "VIP";
})(PRODUCT_BUYING_PROGRAM = exports.PRODUCT_BUYING_PROGRAM || (exports.PRODUCT_BUYING_PROGRAM = {}));

var SALES_CHANNEL;

(function (SALES_CHANNEL) {
  SALES_CHANNEL["DIRECT"] = "DIRECT";
  SALES_CHANNEL["INDIRECT"] = "INDIRECT";
})(SALES_CHANNEL = exports.SALES_CHANNEL || (exports.SALES_CHANNEL = {}));

var PRODUCT_FAMILY;

(function (PRODUCT_FAMILY) {
  PRODUCT_FAMILY["ACROBAT"] = "ACROBAT";
  PRODUCT_FAMILY["CCM_STORAGE"] = "CCM_STORAGE";
  PRODUCT_FAMILY["SIGN"] = "SIGN";
  PRODUCT_FAMILY["SPARK"] = "SPARK";
  PRODUCT_FAMILY["STOCK_ASSETS"] = "STOCK_ASSETS";
  PRODUCT_FAMILY["STOCK_CREDIT_PACK"] = "STOCK_CREDIT_PACK";
  PRODUCT_FAMILY["STOCK_SUBSCRIPTION_PLAN"] = "STOCK_SUBSCRIPTION_PLAN";
})(PRODUCT_FAMILY = exports.PRODUCT_FAMILY || (exports.PRODUCT_FAMILY = {}));

exports.LICENSE_QUANTITY_UNLIMITED = 'UNLIMITED';
exports.FULFILLABLE_ITEM_CONSTANTS = {
  FULFILLABLE_ITEM_CHARGING_MODEL_CAP_UNLIMITED: 'UNLIMITED',
  FULFILLABLE_ITEM_CHARGING_MODEL_TYPE: {
    ON_DEMAND: 'ON_DEMAND',
    RECURRING: 'RECURRING'
  },
  FULFILLABLE_ITEM_CHARGING_UNIT: {
    // case-sensitive
    LICENSE: 'LICENSE',
    TRANSACTIONS: 'transactions'
  },
  FULFILLABLE_ITEM_CODE: {
    ACOM_ESIGN: 'acom_esign',
    ACP_BATCH_DATA_ACTIVATION: 'acp_batch_data_activation',
    ACP_DATA_SCIENCE_WORKSPACE_INTEL_QUOTA: 'acp_data_science_workspace_intel_quota',
    ACP_DATA_SCIENCE_WORKSPACE_NOPRD_PROFILE: 'acp_data_science_workspace_noprd_profile',
    ACP_DATA_SCIENCE_WORKSPACE_RICHNESS: 'acp_data_science_workspace_richness',
    ACP_DATA_SCIENCE_WORKSPACE_SANDBOXES: 'acp_data_science_workspace_sandboxes',
    ACP_DATA_SERVICES_FOUNDATION: 'acp_data_services_foundation',
    ACP_DSF_STREAMING_QUOTA: 'acp_dsf_streaming_quota',
    ACP_HFA: 'acp_hfa',
    ACP_NON_PROD_PROFILES: 'acp_non_prod_profiles',
    ACP_NON_PROD_PROFILES_RICHNESS: 'acp_non_prod_profiles_richness',
    ACP_NON_PROD_STREAMINGSEGMENTATION: 'acp_non_prod_streamingsegmentation',
    ACP_PROFILE_RICHNESS_PACKS: 'acp_profile_richness_packs',
    ACP_RT_CDP_NON_PROD_PROFILES: 'acp_rt_cdp_non_prod_profiles',
    ACP_RT_DATA_ACTIVATION: 'acp_rt_data_activation',
    ACP_SANDBOXES: 'acp_sandboxes',
    ACP_UPS_STRAMINGSEGMENTATION: 'acp_ups_streamingsegmentation',
    APPS_OFFLINE_PROFILES_COUNT: 'apps_offline_profiles_count',
    ASSET_SHARING_POLICY_CONFIG: 'asset_sharing_policy_config',
    BEHANCE: 'behance',
    CC_STORAGE: 'cc_storage',
    CONSUMPTION_CYCLE_DURATION: 'consumption_cycle_duration',
    CONSUMPTION_START_DATE: 'consumption_start_date',
    DC_STORAGE: 'dc_storage',
    DMA_ACP_CS: 'dma_acp_cs',
    DOMAIN_CLAIMING: 'domain_claiming',
    DX_ADOBE_IO_RUNTIME: 'dx_adobe_io_runtime',
    DX_AEM_API_CALLS: 'dx_aem_api_calls',
    DX_AEM_ASSET_SHARE_USERS: 'dx_aem_asset_share_users',
    DX_AEM_BRAND_PORTAL_STORAGE: 'dx_aem_brand_portal_storage',
    DX_AEM_BRAND_PORTAL_USERS: 'dx_aem_brand_portal_users',
    DX_AEM_DYNAMIC_MEDIA: 'dx_aem_dynamic_media',
    DX_AEM_ENVIRONMENT: 'dx_aem_environment',
    DX_AEM_PAGE_VIEWS: 'dx_aem_page_views',
    DX_AEM_STORAGE: 'dx_aem_storage',
    DX_AEM_USERS_CONCURRENT: 'dx_aem_users_concurrent',
    DX_AEM_USERS_LIGHT: 'dx_aem_users_light',
    DX_AEM_USERS_POWER: 'dx_aem_users_power',
    DX_AEM_USERS_STANDARD: 'dx_aem_users_standard',
    DX_CAMPAIGN: 'dx_campaign',
    DX_CJA_API_CALLS: 'dx_cja_api_calls',
    DX_CJA_ATTRIBUTIONS: 'dx_cja_attributions',
    DX_CJA_CALC_METRICS: 'dx_cja_calc_metrics',
    DX_CJA_CONCURRENT_REQUESTS: 'dx_cja_concurrent_requests',
    DX_CJA_DATA_RESTATEMENT: 'dx_cja_data_restatement',
    DX_CJA_DATA_TRANSFER: 'dx_cja_data_transfer',
    DX_CJA_PROFILES: 'dx_cja_profiles',
    DX_CJA_PROFILES_RESTATEMENT: 'dx_cja_profiles_restatement',
    DX_CJA_PROFILE_SIZE: 'dx_cja_profile_size',
    DX_CJA_PROFILE_SIZE_QUANTITY: 'dx_cja_profile_size_quantity',
    DX_JOURNEYS_NON_PROD_PROFILES: 'dx_journeys_non_prod_profiles',
    ESM_SHARED_STORAGE: 'esm_shared_storage',
    ESM_USER_STORAGE: 'esm_user_storage',
    EXPORT_SESSION_CREATION_DISALLOWED: 'disallow_expert_sessions',
    ILLUSTRATOR_CC: 'illustrator_cc',
    INDESIGN_CC: 'indesign_cc',
    LABORATORY_LICENSE_MANAGEMENT: 'laboratory_license_mgmt',
    MKTO: 'MKTO',
    MSFT_INTEGRATION_READINESS: 'msft_integration_readiness',
    OVERDELEGATION_ALLOWED: 'overdelegation_allowed',
    OZ_STORAGE: 'oz_storage',
    PACKAGE_PRECONDITIONING: 'package_preconditioning',
    PHOTOSHOP_CC: 'photoshop_cc',
    PORTFOLIO: 'portfolio',
    PREMIERE_CC: 'premiere_cc',
    PRIVATE_CC_STORAGE: 'private_cc_storage',
    SIGN_SERVICE_LEVEL: 'sign_service_level',
    SINGLE_DESKTOP_APPLICATION_CONFIGURATION: 'single_desktop_application_configuration',
    STOCK_CREDIT: 'stock_credit',
    STOCK_IMAGE: 'stock_image',
    STOCK_PREMIUM_CREDITS: 'stock_premium_credits',
    STOCK_STANDARD_CREDITS: 'stock_standard_credits',
    STOCK_UNIVERSAL_CREDITS: 'stock_universal_credits',
    STOCK_VIDEO: 'stock_video',
    SUPPORTED_PRODUCT: 'supported_product',
    SUPPORT_ALLOWED_ADMINS: 'support_allowed_admins',
    SUPPORT_CASE_CREATION_ALLOWED: 'support_case_creation_allowed',
    SUPPORT_EXPERT_SESSION: 'support_expert_sess',
    SUPPORT_ROLE_ASSIGNMENT_ALLOWED: 'support_role_assignment_allowed',
    TOTAL_SIGN_TRANSACTIONS: 'total_sign_transactions',
    USER_GROUP_ASSIGNMENT: 'user_group_assignment',
    USER_PERMISSION_MANAGEMENT: 'user_permission_management'
  },
  FULFILLABLE_ITEM_DELEGATION_TYPE: {
    GROUP: 'GROUP',
    MACHINE: 'MACHINE',
    NA: 'NA',
    ORGANIZATION: 'ORGANIZATION',
    PERSON: 'PERSON'
  },
  // TODO: remove after removing usage in administration
  FULFILLABLE_ITEM_TYPE: {
    DESKTOP: 'DESKTOP',
    FEATURE: 'FEATURE',
    QUOTA: 'QUOTA',
    SERVICE: 'SERVICE',
    SUPPORT: 'SUPPORT'
  }
}; // Legacy quotas that should not be included in scorecards.
// Any new quota that should be excluded should be set using
// the group parameter scorecard (PRODUCT_GROUP_PARAMETERS_SCORECARD_TYPE)
// instead of in this list.

exports.QUOTA_IGNORE_LIST = [exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_BATCH_DATA_ACTIVATION, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DATA_SCIENCE_WORKSPACE_INTEL_QUOTA, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DATA_SCIENCE_WORKSPACE_NOPRD_PROFILE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DATA_SCIENCE_WORKSPACE_RICHNESS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DATA_SCIENCE_WORKSPACE_SANDBOXES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DATA_SERVICES_FOUNDATION, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_DSF_STREAMING_QUOTA, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_HFA, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_NON_PROD_PROFILES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_NON_PROD_PROFILES_RICHNESS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_NON_PROD_STREAMINGSEGMENTATION, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_PROFILE_RICHNESS_PACKS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_RT_CDP_NON_PROD_PROFILES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_RT_DATA_ACTIVATION, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_SANDBOXES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ACP_UPS_STRAMINGSEGMENTATION, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.CC_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DC_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_ADOBE_IO_RUNTIME, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_API_CALLS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_ASSET_SHARE_USERS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_BRAND_PORTAL_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_BRAND_PORTAL_USERS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_DYNAMIC_MEDIA, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_ENVIRONMENT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_PAGE_VIEWS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_USERS_CONCURRENT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_USERS_LIGHT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_USERS_POWER, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_AEM_USERS_STANDARD, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CAMPAIGN, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_API_CALLS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_ATTRIBUTIONS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_CALC_METRICS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_CONCURRENT_REQUESTS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_DATA_RESTATEMENT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_DATA_TRANSFER, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_PROFILE_SIZE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_PROFILE_SIZE_QUANTITY, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_PROFILES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_CJA_PROFILES_RESTATEMENT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.DX_JOURNEYS_NON_PROD_PROFILES, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ESM_SHARED_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.ESM_USER_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.OZ_STORAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.PRIVATE_CC_STORAGE];
exports.STOCK_QUOTAS = [exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_CREDIT, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_IMAGE, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_PREMIUM_CREDITS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_STANDARD_CREDITS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_UNIVERSAL_CREDITS, exports.FULFILLABLE_ITEM_CONSTANTS.FULFILLABLE_ITEM_CODE.STOCK_VIDEO];
exports.CUSTOMER_SEGMENT = {
  ENTERPRISE: 'ENTERPRISE',
  TEAM: 'TEAM'
};